import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Trash2, Upload } from "lucide-react";
import { API } from "../../config";

const headers = () => ({ "X-Admin-Token": localStorage.getItem("admin_token") || "" });

export const WebPreviewUploader = ({ r, onChange }) => {
  const [caption, setCaption] = useState("");
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  const items = (r.previews || []).filter((p) => !p.is_deleted);
  const upload = async (file) => {
    if (!file) return;
    if (file.size > 10 * 1024 * 1024) { toast.error("Obrázok je väčší ako 10 MB"); return; }
    const fd = new FormData();
    fd.append("file", file); fd.append("caption", caption);
    setBusy(true);
    try {
      const res = await axios.post(`${API}/admin/web-inquiries/${r.id}/previews`, fd, { headers: headers() });
      onChange([...(r.previews || []), res.data]); setCaption(""); toast.success("Náhľad nahraný, zákazník ho vidí na stránke návrhu");
    } catch (e) { toast.error(e.response?.data?.detail === "invalid_type" ? "Povolené sú JPG, PNG alebo WEBP" : "Nahrávanie zlyhalo"); }
    setBusy(false); if (input.current) input.current.value = "";
  };
  const remove = async (pid) => {
    try {
      await axios.delete(`${API}/admin/web-inquiries/${r.id}/previews/${pid}`, { headers: headers() });
      onChange((r.previews || []).map((p) => (p.id === pid ? { ...p, is_deleted: true } : p)));
    } catch { toast.error("Odstránenie zlyhalo"); }
  };
  const src = (pid) => `${API}/web-design/proposal/${r.pay_token}/previews/${pid}`;
  return (
    <div className="mt-2 w-56 space-y-1" data-testid={`web-preview-uploader-${r.id}`}>
      {items.length > 0 && <div className="flex flex-wrap gap-1">{items.map((p) => (
        <div key={p.id} className="relative w-16 h-11 rounded overflow-hidden border border-gray-200" title={p.caption}>
          {r.pay_token ? <img src={src(p.id)} alt={p.caption} className="w-full h-full object-cover" /> : <span className="block p-1 text-[9px] leading-tight text-gray-600">{p.caption || "obrázok"}</span>}
          <button onClick={() => remove(p.id)} className="absolute top-0 right-0 bg-white/90 p-0.5 rounded-bl" aria-label="Odstrániť" data-testid={`web-preview-delete-${p.id}`}><Trash2 className="w-3 h-3 text-red-600" /></button>
        </div>))}</div>}
      {items.filter((p) => p.liked || p.feedback?.some((f) => f.type === "comment")).map((p) => (
        <div key={p.id} className="text-[11px] text-gray-700 border-l-2 border-emerald-500 pl-1" data-testid={`web-preview-feedback-${p.id}`}>
          <b>{p.caption || "Náhľad"}</b>{p.liked && <span className="text-emerald-700"> · ♥ Páči sa</span>}
          {p.feedback?.filter((f) => f.type === "comment").map((f, i) => <p key={i}>„{f.text}“</p>)}
        </div>))}
      <input value={caption} onChange={(e) => setCaption(e.target.value)} placeholder="Popis náhľadu (nepovinné)" className="w-full border border-gray-300 rounded px-2 py-1 text-xs bg-white text-gray-900" data-testid={`web-preview-caption-${r.id}`} />
      <input ref={input} type="file" accept="image/jpeg,image/png,image/webp" className="hidden" onChange={(e) => upload(e.target.files[0])} data-testid={`web-preview-file-${r.id}`} />
      <button onClick={() => input.current?.click()} disabled={busy} className="inline-flex items-center gap-1 text-xs px-2 py-1 rounded bg-blue-600 text-white disabled:opacity-60" data-testid={`web-preview-upload-${r.id}`}>
        {busy ? <Loader2 className="w-3 h-3 animate-spin" /> : <Upload className="w-3 h-3" />}Nahrať náhľad dizajnu</button>
      {!r.pay_token && <p className="text-[11px] text-gray-500">Zákazník náhľady uvidí po schválení návrhu.</p>}
    </div>
  );
};
